import React, { useState, useEffect } from 'react'
import { CardBody, Card, Col, Row, Input, Label, Button, Form, CardHeader } from "reactstrap";
import apiGlobal from '../../global/api.global';
import { useSelector } from 'react-redux';
import { RootState } from '../../';
import { errorToast, successToast } from '../../Components/Toasts';
import MainEnginesRow from './MainEnginesRow';
import { errResponse } from 'GenericForms/Helper';

const Engines = () => {
    const [auxEngines, setAuxEngine] = useState<Array<any>>([]);
    const [auxilleryEngine, setAuxillerEngine] = useState<Array<any>>([]);
    const [mainEng, setMainEng] = useState<Array<any>>([]);
    const [auxEng, setAuxEng] = useState<Array<any>>([]);
    const [mainEngines, setMainEngines] = useState([]);
    const { VesselID, MainEngineRow } = useSelector((state: RootState) => state.Reporting);

    useEffect(() => {
        const loadOptions = async () => {
            await apiGlobal.get(`/main_engine_setting/get_main_engine_setting_by_vessel/?vessel_id=${VesselID}`).then(res => {
                setMainEng(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            })
        }; loadOptions();
    }, [VesselID])

    useEffect(() => {
        const loadOptions = async () => {
            await apiGlobal.get(`/auxillary_machine_setting/get_auxillary_machine_setting_by_vessel/?vessel_id=${VesselID}`).then(res => {
                setAuxEng(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            })
        }; loadOptions();
    }, [VesselID])

    useEffect(() => {
        const loadEngines = async () => {
            await apiGlobal.get(`/vessel_machinery_list/get_machinery_list_by_vessel/?vessel_id=${VesselID}`).then(res => {
                let mEngine = res.data.filter((item: any) => item.precedence_id === 1)
                setMainEngines(mEngine);
                let aEngine = res.data.filter((item: any) => item.precedence_id === 2)
                setAuxEngine(aEngine);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            })
        }; loadEngines();
    }, [VesselID]);

    useEffect(() => {
        if (auxEngines.length > 0) {
            const newAuxilleryEngine = [...auxilleryEngine];

            auxEngines.forEach((engine: any, index: number) => {
                if (auxilleryEngine.length <= auxEngines.length) {
                    newAuxilleryEngine.splice(index, 0, {
                        power_output_rating: 0,
                        rated_voltage: 0,
                        rated_frequency: 0,
                        rated_rpm: 0,
                        alternator_power_rating: 0,
                        eedi: 0,
                        vessel: VesselID,
                        vessel_machinery_name: engine.id
                    })
                }
            })
            setAuxillerEngine(newAuxilleryEngine)
        }
    }, [auxEngines, VesselID])

    function handle_Power_Output_Auxillery_Engine_Changes(e: any, idx: number, machine_id: number) {
        auxilleryEngine[idx].power_output_rating = e.target.value;
    }

    function handle_Rated_Voltage_Auxillery_Engine_Changes(e: any, idx: number, machine_id: number) {
        auxilleryEngine[idx].rated_voltage = e.target.value;
    }

    function handle_Rated_RPM_Auxillery_Engine_Changes(e: any, idx: number, machine_id: number) {
        auxilleryEngine[idx].rated_rpm = e.target.value;
    }

    function handle_Rated_Frequency_Auxillery_Engine_Changes(e: any, idx: number, machine_id: number) {
        auxilleryEngine[idx].rated_frequency = e.target.value;
    }

    function handle_Alternator_Power_Rating_Auxillery_Engine_Changes(e: any, idx: number, machine_id: number) {
        auxilleryEngine[idx].alternator_power_rating = e.target.value;
    }

    function handle_EEDI_Auxillery_Engine_Changes(e: any, idx: number, machine_id: number) {
        auxilleryEngine[idx].eedi = e.target.value;
    }



    const Main_Engine_Submit = (e: any) => {
        apiGlobal.post(`/main_engine_setting/`, MainEngineRow.filter((item: any) => item.shaft_power > 0))
            .then(res => {
                successToast("Data saved successfully!");
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
    }

    const Auxillery_Engine_Submit = (e: any) => {
        apiGlobal.post(`/auxillary_machine_setting/`, auxilleryEngine.filter((item: any) => item.power_output_rating > 0))
            .then(res => {
                successToast("Data saved successfully!");
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
    }
    return (
        <>
            <div>
                {mainEngines.length > 0 ? mainEngines.map((vesselEngine: any, index: number) => {
                    return (
                        <Card key={index}>
                            <CardHeader>
                                <h4 className="page_title pos-start mb-0">{vesselEngine.vessel_machinery_name}</h4>
                            </CardHeader>
                            <CardBody>
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        Main_Engine_Submit(e)
                                        return false;
                                    }}
                                    autoComplete='off'
                                >
                                    <MainEnginesRow mainEng={mainEng} vesselEngine={vesselEngine} mainEngines={mainEngines} index={index} />
                                </Form>
                            </CardBody>
                        </Card>
                    )
                })
                    : <><Label>Please configure main engine for this vessel</Label><br /></>
                }
                {auxEngines.length > 0 ?
                    auxEngines.map((auxEngine: any, index: number) => {
                        return (
                            <>
                                <Card key={index}>
                                    <CardHeader>
                                        <h4 className="page_title pos-start mb-0">{auxEngine.vessel_machinery_name}</h4>
                                    </CardHeader>
                                    <CardBody>
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                Auxillery_Engine_Submit(e)
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="form-floating input-group mb-3">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id={auxEngine.id}
                                                            name="power_output_rating"
                                                            placeholder='example'
                                                            defaultValue={auxEng.length > 0 ? auxEng.find((item: any) => item.vessel_machinery_name === auxEngine.id)?.power_output_rating || '' : ''}
                                                            onBlur={(e) => handle_Power_Output_Auxillery_Engine_Changes(e, index, auxEngine.id)}
                                                        /><div className='input-group-text round_border'>kW</div>
                                                        <Label for="shaft_power">Power output rating</Label></div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="form-floating input-group mb-3">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id={auxEngine.id}
                                                            name="rated_voltage"
                                                            placeholder='example'
                                                            defaultValue={auxEng.length > 0 ? auxEng.find((item: any) => item.vessel_machinery_name === auxEngine.id)?.rated_voltage || '' : ''}
                                                            onBlur={(e) => handle_Rated_Voltage_Auxillery_Engine_Changes(e, index, auxEngine.id)}
                                                        /><div className='input-group-text round_border'>V</div>
                                                        <Label for="shaft_power">Rated voltage</Label></div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="form-floating input-group mb-3">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id={auxEngine.id}
                                                            name="rated_frequency"
                                                            placeholder='example'
                                                            defaultValue={auxEng.length > 0 ? auxEng.find((item: any) => item.vessel_machinery_name === auxEngine.id)?.rated_frequency || '' : ''}
                                                            onBlur={(e) => handle_Rated_Frequency_Auxillery_Engine_Changes(e, index, auxEngine.id)}
                                                        /><div className='input-group-text round_border'>Hz</div>
                                                        <Label for="shaft_power">Rated frequency</Label></div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="form-floating mb-3">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id={auxEngine.id}
                                                            name="rated_rpm"
                                                            placeholder='example'
                                                            defaultValue={auxEng.length > 0 ? auxEng.find((item: any) => item.vessel_machinery_name === auxEngine.id)?.rated_rpm || '' : ''}
                                                            onBlur={(e) => handle_Rated_RPM_Auxillery_Engine_Changes(e, index, auxEngine.id)}
                                                        />
                                                        <Label for="shaft_power">Rated RPM</Label></div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="form-floating input-group mb-3">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id={auxEngine.id}
                                                            name="alternator_power_rating"
                                                            placeholder='example'
                                                            defaultValue={auxEng.length > 0 ? auxEng.find((item: any) => item.vessel_machinery_name === auxEngine.id)?.alternator_power_rating || '' : ''}
                                                            onBlur={(e) => handle_Alternator_Power_Rating_Auxillery_Engine_Changes(e, index, auxEngine.id)}
                                                        /><div className='input-group-text round_border'>kVA</div>
                                                        <Label for="shaft_power">Alternator power rating</Label>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="form-floating mb-3">
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id={'eedi' + auxEngine.id}
                                                            name="eedi"
                                                            placeholder='example'
                                                            defaultValue={auxEng.length > 0 ? auxEng.find((item: any) => item.vessel_machinery_name === auxEngine.id)?.eedi || '' : ''}
                                                            onBlur={(e) => handle_EEDI_Auxillery_Engine_Changes(e, index, auxEngine.id)}
                                                        />
                                                        <Label for={'eedi' + auxEngine.id}>EEDI</Label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div className="d-flex flex-wrap btn_Margin">
                                                        <Button type="submit" color='primary' className='pos-end'>Save</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </>
                        )
                    })
                    : <Label>Please configure auxiliary engines for this vessel</Label>
                }
            </div>
        </>
    )
}

export default Engines;